import { render, staticRenderFns } from "./pickingTasksDetail.vue?vue&type=template&id=63a43f22&scoped=true&"
import script from "./pickingTasksDetail.vue?vue&type=script&lang=js&"
export * from "./pickingTasksDetail.vue?vue&type=script&lang=js&"
import style0 from "./pickingTasksDetail.vue?vue&type=style&index=0&id=63a43f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a43f22",
  null
  
)

export default component.exports